import styled from "@emotion/styled";
import { VerticalGapProps } from "./vertical-gap.props";

export const VerticalGap = styled.div`
  margin: ${(props: VerticalGapProps) => `${props.gapInPx || "16"}px`};
`;
